module.exports = __webpack_public_path__ + "media/images/svg/calendar-6532df3104568b45d5ca80af89978825.svg";